module.exports = __webpack_public_path__ + "img/SESSIONS.51fe9c0f.png";